var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"borderIcon",attrs:{"size":_vm.size}},[_c('span',{staticClass:"headline initialLetters",style:(_vm.getFontSize())},[_vm._v(_vm._s(_vm.initialLetters()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }